/**
 * Minimal trailing-edge debounce — replaces `debounce` from `@mui/material/utils`
 * for the geo-search keystroke hooks (GeoSelector, forum/step3).
 */
// biome-ignore lint/suspicious/noExplicitAny: generic passthrough args
export const debounce = <T extends (...args: Array<any>) => void>(fn: T, waitMs: number) => {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), waitMs);
  };
};
